class FooterNewsletter extends HTMLElement {
  static SESSION_SUPPRESS_KEY = 'newsletter_footer_engaged';
  static EXPAND_MIN_CHARS = 3;

  connectedCallback() {
    this.form = this.querySelector('form');
    this.emailInput = this.querySelector('[data-newsletter-email]');
    this.nameFields = this.querySelector('[data-newsletter-name-fields]');

    if (!this.emailInput || !this.nameFields) return;

    this.onEmailInput = this.onEmailInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onEngage = this.onEngage.bind(this);

    this.emailInput.addEventListener('input', this.onEmailInput);
    this.emailInput.addEventListener('change', this.onEmailInput);
    this.form?.addEventListener('submit', this.onSubmit);
    this.form?.addEventListener('focusin', this.onEngage);

    if (this.querySelector('.newsletter-errors') || this.shouldExpand()) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  disconnectedCallback() {
    this.emailInput?.removeEventListener('input', this.onEmailInput);
    this.emailInput?.removeEventListener('change', this.onEmailInput);
    this.form?.removeEventListener('submit', this.onSubmit);
    this.form?.removeEventListener('focusin', this.onEngage);
  }

  onEngage() {
    if (sessionStorage.getItem(FooterNewsletter.SESSION_SUPPRESS_KEY) === '1') return;

    sessionStorage.setItem(FooterNewsletter.SESSION_SUPPRESS_KEY, '1');
    document.dispatchEvent(new CustomEvent('newsletter:footer-engaged'));
  }

  shouldExpand() {
    return (this.emailInput?.value.trim().length || 0) >= FooterNewsletter.EXPAND_MIN_CHARS;
  }

  onEmailInput() {
    if (this.shouldExpand()) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  onSubmit(event) {
    if (!this.classList.contains('is-expanded')) {
      event.preventDefault();
      if (this.shouldExpand()) {
        this.expand();
      }
    }
  }

  expand() {
    this.classList.add('is-expanded');
    this.nameFields.setAttribute('aria-hidden', 'false');
  }

  collapse() {
    this.classList.remove('is-expanded');
    this.nameFields.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('footer-newsletter', FooterNewsletter);
